var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Store Orders"}},[_c('Load'),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('List',{on:{"select":_vm.selectOrder}})],1),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('div',{staticClass:"s-vstack"},[_c('MissedTransactions'),_c('div',[_c('LoadTransaction')],1)],1)])],1),_c('OrderDetail',{ref:"detail"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }